import { render, staticRenderFns } from "./user-picker.vue?vue&type=template&id=7b4930c0"
import script from "./user-picker.vue?vue&type=script&lang=js"
export * from "./user-picker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports